export class Phone{
	init(){
		$(document).on('click', '.phone-button', function() {
			$(this).html($(this).data('number')).addClass('clicked');

			var $this = $(this),
				category = $('.features-list--specialization .active span').text(),
				voivodeship = $this.data('voivodeship'),
				county = $this.data('count'),
				number = document.getElementsByClassName('consultant__phone')[0].innerText;

			ga("send", "event", category, voivodeship + ' - ' + county, number )
		});

		$('.btn-advisors').on('click', function() {
			ga("send", "event", "button", "Klik", "znajdź doradcę - top");		
		});
		$('.btn-parameters').on('click', function() {
			ga("send", "event", "button", "Klik", "znajdź doradcę - bottom");		
		})
	}
}